import { render, staticRenderFns } from "./SignMessage.vue?vue&type=template&id=ec8f0e6a&"
import script from "./SignMessage.vue?vue&type=script&lang=js&"
export * from "./SignMessage.vue?vue&type=script&lang=js&"
import style0 from "./SignMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports